import { buildGuidesQueryParams } from '@/modules/guias/guidesFilters.js';

const API_BASE_URL = import.meta.env.VITE_API_URL || '';
const GUIDES_BASE_URL = `${API_BASE_URL}/api/guias`;

const buildHeaders = () => {
  const headers = { 'Content-Type': 'application/json' };

  try {
    const token = localStorage.getItem('token');
    const tenantRaw = localStorage.getItem('tenant');

    if (token) headers.Authorization = `Bearer ${token}`;

    if (tenantRaw) {
      try {
        const tenant = JSON.parse(tenantRaw);
        headers['X-Tenant'] = tenant?.code || tenant?.domain || tenantRaw;
      } catch {
        headers['X-Tenant'] = tenantRaw;
      }
    }
  } catch {
    // noop
  }

  return headers;
};

export async function fetchGuides({ filters = {}, page = 1, limit = 20, sortBy, sortDirection, extraFilters = {} } = {}) {
  const params = buildGuidesQueryParams(filters, { page, limit, sortBy, sortDirection }, extraFilters);
  const response = await fetch(`${GUIDES_BASE_URL}?${params.toString()}`, {
    headers: buildHeaders(),
    credentials: 'include',
  });
  const payload = await response.json();

  if (!response.ok || !payload?.ok) {
    const message = payload?.error || 'No se pudo obtener el listado de guías.';
    throw new Error(message);
  }

  return payload;
}

export async function searchGuides(filters) {
  const payload = await fetchGuides({ filters, page: 1, limit: 5 });
  return (payload.data || []).map(item => ({
    guia: item.nro_guia || item.id,
    remito: item.remito || '—',
    envia: item.remitente || item.cliente || '—',
    recibe: item.destinatario || '—',
    domicilio: item.domicilio || '—',
    fecha: item.fecha || '',
  }));
}

export async function fetchGuideDetail(id) {
  const response = await fetch(`${GUIDES_BASE_URL}/${id}`, {
    headers: buildHeaders(),
    credentials: 'include',
  });
  const payload = await response.json();

  if (!response.ok || !payload?.ok) {
    const message = payload?.error || 'No se pudo obtener el detalle de la guía.';
    throw new Error(message);
  }

  return payload;
}

export async function fetchGuideTimeline(id) {
  const response = await fetch(`${GUIDES_BASE_URL}/${id}/timeline`, {
    headers: buildHeaders(),
    credentials: 'include',
  });
  const payload = await response.json();

  if (!response.ok || !payload?.ok) {
    const message = payload?.error || 'No se pudo obtener el timeline de la guía.';
    throw new Error(message);
  }

  return payload;
}

export async function fetchGuideOperationalContext(id) {
  const response = await fetch(`${GUIDES_BASE_URL}/${id}/operational-context`, {
    headers: buildHeaders(),
    credentials: 'include',
  });
  const payload = await response.json();
  if (!response.ok || !payload?.ok) throw new Error(payload?.error || 'No se pudo obtener el contexto operativo de la guía.');
  return payload.data || payload;
}
